<ng-template #userHelpDialog>
<div class="user-help-dialog">
    <div class="user-help-dialog-content">
        <h4>Help</h4>
        <div class="user-help-body">
            Production Users having trouble logging in ? (example, 2-factor, Password issues or
            resetting
            Security Questions)<br>
            Please request users to reach out to Disney IT support helpdesk.<br><br>

            <b>Disney IT: Toll Free:</b> 1-866-534-7639, <b>Tie Line:</b> 8665<br>
            <b>Support hours:</b> 24/7<br>
            <u><a
                    href="https://disney.service-now.com/dtoolsitsp?id=kb_article&sys_id=3b3f1189dbec6fc4b7915540cf961951">APAC</a></u>,
            <u><a
                    href="https://disney.service-now.com/dtoolsitsp?id=kb_article&sys_id=dab407a5130167c84175b7a66144b026">EMEA</a></u>,
            <u><a
                    href="https://disney.service-now.com/dtoolsitsp?id=disney_kb_article&sys_id=c0d7e2a21332e748c194b6076144b0f7">HKDL</a></u>,
            <u><a
                    href="https://disney.service-now.com/dtoolsitsp?id=disney_kb_article&sys_id=51ad161ddbc16fc800c09ed6db961917">LTAM</a></u>,
            <u><a
                    href="https://disney.service-now.com/dtoolsitsp?id=disney_kb_article&sys_id=2ee00092dbe30018fd07b5b968961984">TFCF</a></u>
        </div>
    </div>
    <div class="user-help-dialog-footer">
        <button type="button" mat-button mat-dialog-close>CLOSE</button>
    </div>
</div>
</ng-template>